exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".help-button-left{position:absolute;bottom:10px;right:15px}button.help-button{border-radius:0}.help-modal .modal-body{padding:31px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/common/session-notification/session-notification.styl
// module id = 629
// module chunks = 0